<template>
  <Toast />
  <div class="card-header">
    <h4>Tipo Movimientos</h4>
    <div class="line_title"></div>
  </div>
  <div class="card-body">
    <div>      
      <!-- DT Usuarios -->
      <DataTable ref="dt" :value="tmovimientos" :paginator="true" :rows="10" style="zoom: 0.80;" :loading="loading" 
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros" :filters="filters"
        v-model:selection="selectedTMovimientos" responsiveLayout="scroll" breakpoint="990px">

        <template #header>
          <!-- DT Toolbar-->
          <Toolbar class="">
            <template #start>
              <div class="table-header flex flex-column md:flex-row md:justiify-content-between">
                <span class="p-input-icon-left">
                  <i class="pi pi-search" />
                  <InputText v-model="filters['global'].value" placeholder="Buscar..." />
                </span>
              </div>              
            </template>

            <template #end>
              <Button label="Crear" icon="pi pi-plus" class="p-button-success" @click="openNew" />
              &nbsp;
              <Button label="Borrar" icon="pi pi-trash" class="p-button-danger" @click="confirmDeleteSelected"
                :disabled="!selectedTMovimientos || !selectedTMovimientos.length" />
              &nbsp;
              <!-- <Button label="Descargar" icon="pi pi-download" class="p-button-help" @click="exportCSV($event)" /> -->
            </template>
          </Toolbar>
        </template>

        <Column selectionMode="multiple" style="width: 3rem" :exportable="false"></Column>       

        <Column field="id" header="Código" >
          <template #body="slotProps">
            <span>
              {{ slotProps.data.id }}
            </span>
          </template>
        </Column>

        <Column field="nombre" header="Movimiento" >
          <template #body="slotProps">
            <span>
              {{ slotProps.data.nombre }}
            </span>
          </template>
        </Column>

        <Column field="tipo" header="Tipo" style="max-width: 14%">
          <template #editor="{ data, field }">
            <AutoComplete v-model="data[field]" :optionValue="data[field]" :suggestions="filteredTipo"
              @complete="searchTipo($event)" dropdown/>
          </template>
        </Column>        

        <Column field="vigente" header="Estado" >
          <template #body="slotProps">
            <Tag :value="slotProps.data.vigente ? 'ACTIVO' : 'INACTIVO'" :severity="slotProps.data.vigente ? 'success' : 'danger'" />
          </template>   
        </Column>
        <Column header="Acciones" :exportable="false" style="white-space: nowrap;">
          <template #body="slotProps">
            <Button icon="pi pi-pencil" class="p-button-rounded p-button-warning"
              @click="editTMovimiento(slotProps.data)" />&nbsp;
            <Button icon="pi pi-trash" class="p-button-rounded p-button-danger"
              @click="confirmDeleteTMovimiento(slotProps.data)" />
          </template>
        </Column>
      </DataTable>
    </div>

    <!-- Formulario TMovimientos en modal -->
    <Dialog v-model:visible="tmovimientoDialog" :style="{ width: '50%' }" header="Datos del Tipo de Movimiento" :modal="true"
      class="p-fluid" :maximizable="true">
      <form class="p-fluid">
        <div class="row">          
          <div class="col-md-1 field">
            <label for="id" class="mt-3">Código</label>
            <InputNumber id="id" v-model="form.id" autofocus autocomplete="off" readonly disabled/>
          </div>     
          <div class="col-md-9 field">
            <label for="nombre" class="mt-3">Tipo de Movimiento</label>
            <InputText id="nombre" v-model="v$.nombre.$model"
              :class="{ 'p-invalid': v$.nombre.$invalid && submitted }" aria-describedby="nombre-error" autofocus
              autocomplete="off" />
            <span v-if="v$.nombre.$error && submitted">
              <span id="nombre-error" v-for="(error, index) of v$.nombre.$errors" :key="index">
                <small class="p-error">{{ error.$message }} </small>
              </span>
            </span>
            <small v-else-if="(v$.nombre.$invalid && submitted) || v$.nombre.$pending.$response" class="p-error">
              {{ v$.nombre.required.$message.replace('Value', 'RUT') }}</small>
          </div> 
          <div class="col-md-2 field">
            <label for="tipo" class="mt-3">Tipo</label>
            <AutoComplete id="tipo" v-model="v$.tipo.$model"
              :class="{ 'p-invalid': v$.tipo.$invalid && submitted }" :suggestions="filteredTipo" 
              @complete="searchTipo($event)" :dropdown="true" forceSelection
              aria-describedby="tipo-error" autofocus autocomplete="off" />
            <span v-if="v$.tipo.$error && submitted">
              <span id="tipo-error" v-for="(error, index) of v$.tipo.$errors" :key="index">
                <small class="p-error">{{ error.$message }}</small>
              </span>
            </span>
            <small v-else-if="((v$.tipo.$invalid && submitted) || v$.tipo.$pending.$response)"
              class="p-error">
              {{ v$.tipo.required.$message.replace('Value', 'Tipo') }}</small>            
          </div>     
        </div>

        <div class="row">
          <div class="col-md-8 field">
            <label for="observacion" class="mt-3">Observaciones</label>
            <InputText id="observacion" v-model.trim="form.observacion" />
          </div>          
          <div class="col-md-4 field">
            <label for="vigente" class="mt-3">Estado</label><br>
            <ToggleButton id="vigente" v-model="v$.vigente.$model"
              :class="{ 'p-invalid': v$.vigente.$invalid && submitted }" onLabel="ACTIVO" offLabel="INACTIVO"
              onIcon="pi pi-check" offIcon="pi pi-times" aria-describedby="vigente-error" autofocus
              style="width: 100%" />
            <span v-if="v$.vigente.$error && submitted">
              <span id="vigente-error" v-for="(error, index) of v$.vigente.$errors" :key="index">
                <small class="p-error">{{ error.$message }}</small>
              </span>
            </span>
            <small v-else-if="(v$.vigente.$invalid && submitted) || v$.vigente.$pending.$response" class="p-error">
              {{ v$.vigente.required.$message.replace('Value', 'Estado') }}</small>
          </div>
        </div>
      </form>
      <template #footer>
        <div class="row">
          <div class="col-md-7 fw-lighter text-muted" style="text-align: left;">
            <small v-if="form.created_id" ><i class="pi pi-user-plus" style="font-size: 1rem"></i>: {{form.created_id.name}} el {{form.created_at}}</small><br/>
            <small v-if="form.updated_id"><i class="pi pi-user-edit" style="font-size: 1rem"></i>: {{form.updated_id.name}} el {{form.updated_at}}</small>    
          </div>  
          <div :class="form.created_id ? 'col-md-5 field' : 'col-md-12 field'" v-if="!saving">
            <Button label="Cancelar" icon="pi pi-times" class="p-button-text text-danger" @click="hideDialog" />
            <Button label="Guardar" icon="pi pi-check" class="p-button-text" @click="saveTMovimiento" />
          </div>
          <div :class="form.created_id ? 'col-md-5 field' : 'col-md-12 field'" v-else>
            <ProgressBar mode="indeterminate"/>
          </div>
        </div>
      </template>
    </Dialog>

    <!-- Confirmar elimina un tmovimiento -->
    <Dialog v-model:visible="deleteTMovimientoDialog" :style="{ width: '470px' }" header="Confirmar" :modal="true">
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle mr-3 text-warning" style="font-size: 2rem; vertical-align: middle;" />
        <span v-if="tmovimiento"> ¿Está seguro de borrar el TMovimiento?</span>
      </div>
      <template #footer>
        <Button label="No" icon="pi pi-times" class="p-button-text" @click="deleteTMovimientoDialog = false" />
        <Button label="Si" icon="pi pi-check" class="p-button-text text-danger" @click="deleteTMovimiento" />
      </template>
    </Dialog>

    <!-- Confirmar elimina masivamente tmovimientos -->
    <Dialog v-model:visible="deleteTMovimientosDialog" :style="{ width: '470px' }" header="Confirmar" :modal="true">
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle mr-2 text-warning" style="font-size: 2rem; vertical-align: middle;" />
        <span v-if="selectedTMovimientos"> ¿Está seguro de borrar los tmovimientos?</span>
      </div>
      <template #footer>
        <Button label="No" icon="pi pi-times" class="p-button-text" @click="deleteTMovimientosDialog = false" />
        <Button label="Si" icon="pi pi-check" class="p-button-text text-danger" @click="deleteSelectedTMovimientos" />
      </template>
    </Dialog>
  </div>
</template>

<script>
import useTMovimientos from '../../composables/cruds/tmovimientos'
import { reactive, onMounted } from 'vue'

import useVuelidate from '@vuelidate/core'
import { required, helpers } from '@vuelidate/validators'

export default {
  setup() {
    const {
      tmovimiento,
      tmovimientos,
      tipos,
      filteredTipo,
      dt, 
      loading, 
      saving,
      filters,
      selectedTMovimientos,
      deleteTMovimientosDialog,
      deleteTMovimientoDialog,
      tmovimientoDialog,
      submitted,
      storeTMovimiento,      
      deleteSelectedTMovimientos,
      getCRUD,
      deleteTMovimiento
    } = useTMovimientos()

    const form = reactive({
      nombre: '',
      tipo: '',
      observacion: '',
      vigente: ''
    })

    const rules = {
      nombre: { required: helpers.withMessage('El campo es requerido', required)},
      tipo: { required: helpers.withMessage('El campo es requerido', required) },
      vigente: { required: helpers.withMessage('El campo es requerido', required) }
    }

    const exportCSV = () => {
      // console.info(dt.value)
      dt.value.exportCSV()
    }

    const confirmDeleteSelected = () => {
      deleteTMovimientosDialog.value = true
    }

    const confirmDeleteTMovimiento = (desp) => {
      tmovimiento.value = desp
      deleteTMovimientoDialog.value = true
    }

    const openNew = () => {
      tmovimiento.value = {}
      submitted.value = false
      tmovimientoDialog.value = true
      saving.value = false

      form.id = null
      form.nombre = ''
      form.tipo = ''
      form.observacion = ''
      form.vigente = true

      form.created_at = ''
      form.created_id = ''
      form.updated_at = ''
      form.updated_id = ''         
    }

    const hideDialog = () => {
      tmovimientoDialog.value = false
      submitted.value = false
      saving.value = false
    }

    const editTMovimiento = (desp) => {
      tmovimiento.value = { ...desp }
      tmovimientoDialog.value = true

      form.id = tmovimiento.value.id
      form.nombre = tmovimiento.value.nombre
      form.tipo = tmovimiento.value.tipo
      form.observacion = tmovimiento.value.observacion
      form.vigente = tmovimiento.value.vigente
      
      form.created_at = tmovimiento.value.created_at
      form.created_id = tmovimiento.value.created_id
      form.updated_at = tmovimiento.value.updated_at
      form.updated_id = tmovimiento.value.updated_id
    }

    const searchTipo = (event) => {
      setTimeout(() => {
        if (!event.query.trim().length) {
          filteredTipo.value = [...tipos.value]
        } else {
          filteredTipo.value = tipos.value.filter((tipo) => {
            return tipo.toUpperCase().startsWith(event.query.toUpperCase())
          })
        }
      }, 250)
    }

    const saveTMovimiento = () => {
      submitted.value = true
      if(!v$._value.$invalid)
        storeTMovimiento(form)  
    }

    const v$ = useVuelidate(rules, form)

    onMounted(getCRUD)

    return {
      dt, 
      loading,
      saving,
      tmovimiento,
      tmovimientos,
      tipos,
      filteredTipo,
      filters,
      selectedTMovimientos,
      deleteTMovimientosDialog,
      deleteTMovimientoDialog,
      tmovimientoDialog,
      submitted,
      v$,
      form,
      hideDialog,
      openNew,
      confirmDeleteTMovimiento,
      deleteSelectedTMovimientos,
      deleteTMovimiento,
      exportCSV,
      confirmDeleteSelected,
      editTMovimiento,
      saveTMovimiento,
      storeTMovimiento,
      searchTipo
    }
  },
}
</script>